import { render, staticRenderFns } from "./order_product_send.vue?vue&type=template&id=0dbedac1"
import script from "./order_product_send.vue?vue&type=script&lang=js"
export * from "./order_product_send.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports